"use client";
import React, { useState } from "react";
import { Download, CheckCircle, Loader } from "lucide-react";

interface DownloadReportFieldProps {
    status: string;
    rawProductFeedValidationReportLocation?: string;
}

const DownloadReportField: React.FC<DownloadReportFieldProps> = ({
    status,
    rawProductFeedValidationReportLocation,
}) => {
    const [isDownloaded, setIsDownloaded] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const isCompleted = status === "completed";

    const handleDownload = () => {
        if (showLoading) return; // Prevent spam clicks
        if (isCompleted && rawProductFeedValidationReportLocation) {
            setShowLoading(true);

            // Simulate async behavior with a small delay
            setTimeout(() => {
                const link = document.createElement("a");
                link.href = rawProductFeedValidationReportLocation;
                link.download = ""; // browser decides filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                setIsDownloaded(true);
                setShowLoading(false);

                // Reset "downloaded" state after few seconds (optional UX improvement)
                setTimeout(() => setIsDownloaded(false), 3000);
            }, 1000); // 1s delay for spinner visibility
        }
    };


    return (
        <div className="flex items-center space-x-2">
            <div className="flex-1">
                <div
                    className={`relative ${isCompleted ? "cursor-pointer" : "cursor-not-allowed"
                        }`}
                    onClick={isCompleted ? handleDownload : undefined}
                >
                    <input
                        type="text"
                        value={
                            showLoading
                                ? "Downloading Report..."
                                : isDownloaded
                                    ? "Report Downloaded"
                                    : "Download Report"
                        }
                        readOnly
                        className={`w-full px-3 py-2 border rounded-md bg-gray-50 
              ${isCompleted
                                ? "border-blue-500 text-blue-600 hover:bg-blue-50"
                                : "border-gray-300 text-gray-500"
                            }
              ${showLoading ? "text-gray-400 italic" : ""}
              ${isCompleted ? "cursor-pointer" : "cursor-not-allowed"}
            `}
                    />

                    {/* Status Icon */}
                    {showLoading ? (
                        <Loader className="absolute right-3 top-2.5 h-4 w-4 text-gray-400 animate-spin" />
                    ) : isDownloaded ? (
                        <CheckCircle className="absolute right-3 top-2.5 h-4 w-4 text-green-500" />
                    ) : (
                        <Download
                            className={`absolute right-3 top-2.5 h-4 w-4 ${isCompleted ? "text-blue-500" : "text-gray-400"
                                }`}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default DownloadReportField;
